import React, { Suspense } from 'react';
import { importFromS3 } from '../../utils/importFromS3';

// Runtime dependency
const AuthPlugin = React.lazy(() => importFromS3('tcc-auth-plugin'));

export const AuthPluginContainer = () => (
  <Suspense fallback={<div data-test-id="authPlugin-container" />}>
    <AuthPlugin />
  </Suspense>
);
